import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

export const PageContainer = styled(Paper)(({ theme }) => ({
  height: "100%",
  width: "100%",
  "& .MuiDataGrid-root": {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const ToolbarContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start", // 從 space-between 改為 flex-start
  alignItems: "center",
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  "& > h6": {
    marginRight: theme.spacing(2), // 給標題右側添加間距
  },
}));
